import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import { LoginEnums } from '../enums';
import { LoginAction } from '../store/auth.actions';
import { SetLoading } from 'src/app/shared/store/shared.actions';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { BASE_URL } from 'src/environments/environment';
import { AuthService } from '../services/auth.service';
import { ActivatedRoute } from '@angular/router';
import { emailValidator } from 'src/app/shared/validators/fields-validators';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
})
export class LoginPageComponent implements OnInit {
  loginEnums = LoginEnums;
  loginForm!: FormGroup;

  currentYear: number = new Date().getFullYear();
  currentLang: Observable<string> = this.store.select((state) => state.shared.currentLang);
  passwordVisible = false; // Initial state: password hidden
  togglePasswordVisibility() {
    this.passwordVisible = !this.passwordVisible;
  }
  BASE_URL = BASE_URL;

  constructor(
    public fb: FormBuilder,
    private route: ActivatedRoute,
    private readonly store: Store<AppState>,
    private readonly translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      database: [''],
      email: ['', Validators.compose([emailValidator(), Validators.required])],
      password: ['', Validators.compose([Validators.required, Validators.minLength(4)])],
    });
  }

  switchLanguage(lang: string) {
    if (lang !== this.translateService.currentLang) this.translateService.use(lang);
  }

  loginAction(): boolean {
    localStorage.clear();

    if (!this.loginForm.valid) {
      this.loginForm.markAllAsTouched();
      return false;
    }

    const next = this.route.snapshot.queryParams['next'] || null;

    this.store.dispatch(SetLoading({ isAppLoading: true }));
    this.store.dispatch(LoginAction({ payload: this.loginForm.value, next }));

    return true;
  }
}
